/**
 * Whether the 2.0 room may show on THIS client (Build 35, founder ruling 2026-11-02).
 *
 * `chat_2_0_v1` is a server flag with no build check, and the room waits for the build that carries it finished. The
 * iOS app (Build 35 as 1.2) therefore never shows the room, whatever the flag says: the chat route stays the per-coach
 * surface, the "Ask a coach" pill and the retired floating button's gate read as with the flag off, and the room stream
 * stays off. The web is unchanged.
 *
 * Every client read of `chat_2_0_v1` that decides what the athlete sees goes through this helper (`routes/chat.tsx`,
 * `components/Fab/useRoomEntryFlag.ts`, `hooks/useRoomStream.ts`). A later build that ships the finished room changes
 * this one function. Read at call time, never cached, so a test can switch the platform.
 */
import { isNativeApp } from './platform';

export function roomAvailableOnThisClient(): boolean {
  return !isNativeApp();
}
